import React, { useState } from "react";
import { MessageCircle, Send, X, Plus } from "lucide-react";
import { useApp } from "@/lib/AppContext";

export default function FloatingContact() {
  const { settings } = useApp();
  const [open, setOpen] = useState(false);

  const tg = settings?.telegram_url;
  const wa = settings?.whatsapp_url;
  if (!tg && !wa) return null;

  return (
    <div className="floating-contact" data-testid="floating-contact">
      {open && (
        <div className="absolute bottom-16 right-0 flex flex-col gap-3 mb-2">
          {tg && (
            <a
              href={tg}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-transform hover:scale-110"
              style={{ background: "#229ED9" }}
              aria-label="Написать в Telegram"
              data-testid="floating-telegram"
            >
              <Send size={20} className="text-white" />
            </a>
          )}
          {wa && (
            <a
              href={wa}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-transform hover:scale-110"
              style={{ background: "#25D366" }}
              aria-label="Написать в WhatsApp"
              data-testid="floating-whatsapp"
            >
              <MessageCircle size={20} className="text-white" />
            </a>
          )}
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-14 h-14 rounded-full flex items-center justify-center shadow-xl transition-transform hover:scale-110"
        style={{ background: "var(--color-primary)" }}
        aria-label={open ? "Закрыть контакты" : "Открыть контакты"}
        data-testid="floating-toggle"
      >
        {open ? <X size={22} className="text-white" /> : <MessageCircle size={22} className="text-white" />}
      </button>
    </div>
  );
}
